import React, { useEffect } from "react";
import EventBus from "@/lib/eventBus";
import { CircleCheck, CircleX, X } from "lucide-react";

const Flash: React.FC = () => {
  const [isFlashOpen, setIsFlashOpen] = React.useState(false);
  const [flashMessage, setFlashMessage] = React.useState("");
  const [isFlashError, setIsFlashError] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);

  useEffect(() => {
    EventBus.$on("flash:open", (type: string, msg: string) => {
      setFlashMessage(msg);
      if (type === "error") {
        setIsFlashError(true);
      } else {
        setIsFlashError(false);
      }
      setIsFlashOpen(true);
      // Trigger fade in animation
      setTimeout(() => setIsVisible(true), 10);
    });
    return () => {
      EventBus.$off("flash:open");
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Wait for fade out animation to complete before hiding
    setTimeout(() => setIsFlashOpen(false), 300);
  };

  return (
    <div
      className={`${
        isFlashOpen ? "flex" : "hidden"
      } items-center gap-x-4 absolute bg-white rounded-xl shadow-lg w-fit py-2 px-3 z-40 top-6 left-0 right-0 mx-auto transition-opacity duration-300 ease-in-out ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      {!isFlashError && (
        <CircleCheck className="text-deck-positive cursor-pointer" size={20} />
      )}
      {isFlashError && (
        <CircleX className="text-deck-danger cursor-pointer" size={20} />
      )}
      <span className="font-semibold text-deck-primary pr-8">
        {flashMessage}
      </span>
      <X
        className="text-deck-primary cursor-pointer"
        size={20}
        onClick={handleClose}
      />
    </div>
  );
};

export default Flash;
